<template>
  <carousel-wrapper ref="carousel">
    <card
      v-if="option.show"
      v-for="(option, index) in formattedOptions"
      :key="index"
      :option="option"
      :index="index"
      ref="card"
      @click="handleActionInCard(index)"
    />
  </carousel-wrapper>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import CarouselWrapper from 'components/CarouselWrapper/CarouselWrapper.vue';
  import Card from 'components/DynamicFilters/Card/Card.vue';
  import OptionCards from 'components/DynamicFilters/OptionCards/OptionCards.vue';
  import useFilters from 'composables/useFilters';
  import getLastTld from 'common/services/utils/getLastTld';
  import box from 'common/icons/Gift2.svg';
  import activity from 'common/icons/Spark.svg';
  import travel from 'common/icons/Map.svg';

  @Component({
    components: {
      CarouselWrapper,
      Card,
      OptionCards,
    },
    props: {
      optionsToDisplay: {
        type: Array,
        required: false,
        description: 'Array of strings with options to display',
        default: ['box', 'activity', 'travelUy'],
      },
    },
    setup() {
      const { getOptionCards } = useFilters();
      return {
        optionCards: getOptionCards,
      };
    },
  })
  export default class CarouselCategorySlider extends Vue {
    icons = {
      box,
      activity,
      travelUy: travel,
    };

    items = ['Regalos con opciones', 'Actividades', 'Viajes', 'Ocasiones'];
    activeIndex = 0;

    handleActionInCard(index) {
      this.activeIndex = index;
      this.$refs.carousel.scrollToItem(index);
    }

    shouldShowOption(option, optionsToDisplay, getLastTld) {
      if (option.name === 'travelUy') {
        return getLastTld() === 'uy';
      } else {
        return optionsToDisplay.includes(option.name);
      }
    }

    get formattedOptions() {
      return this.optionCards.map((option, index) => {
        const show = this.shouldShowOption(
          option,
          this.optionsToDisplay,
          getLastTld,
        );
        return {
          id: index,
          name: option.name,
          icon: this.icons[option.name],
          title: option.title,
          description: option.description,
          show: show,
        };
      });
    }
  }
</script>

<style lang="scss" scoped></style>
